import {StyleSheet} from 'react-native';

import {black, white} from '/theme/color/on.color';
import {alto} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  base: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    flexDirection: 'row',
  },
  contentFiller: {
    flex: 1,
    height: '100%',
  },
  contentWrapper: {
    backgroundColor: white,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    height: '100%',
    width: 400,
    shadowColor: '#000',
    shadowOffset: {
      width: -10,
      height: 0,
    },
    shadowOpacity: 0.5,
    shadowRadius: 20,
    zIndex: 1,
    borderLeftWidth: 1,
    borderLeftColor: alto,
  },
  contentMeasurer: {
    opacity: 0,
    position: 'absolute',
    width: 400,
    right: -400,
  },
  backdrop: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: black,
    opacity: 0.4,
  },
});
